import sanitizeHtmlLib, { type IOptions } from "sanitize-html"

/**
 * Sanitises CMS-authored HTML before it goes through dangerouslySetInnerHTML.
 * Pure JS (no DOM emulation needed), so it's safe to use from both Server and
 * Client Components.
 */
export function sanitizeHtml(dirty: string): string {
  return sanitizeHtmlLib(dirty)
}

// The rich text pipeline in parseBody() (src/lib/utils.ts) reconstructs
// <a>/<table>/<h2>/<button> tags with specific attributes (id for h2 anchors,
// class for the table-fade wrapper, rel for noopener links). The default
// allowlist would silently strip those and break existing functionality, so
// this variant extends it to match exactly what parseBody() can produce.
const richTextOptions: IOptions = {
  allowedTags: sanitizeHtmlLib.defaults.allowedTags.concat(["button"]),
  allowedAttributes: {
    ...sanitizeHtmlLib.defaults.allowedAttributes,
    a: ["href", "id", "class", "title", "target", "rel"],
    div: ["class"],
    button: ["class"],
    h2: ["id"],
  },
}

export function sanitizeRichText(dirty: string): string {
  return sanitizeHtmlLib(dirty, richTextOptions)
}
